<h1 mat-dialog-title>Add Induction Type</h1>
<div mat-dialog-content>
 
 
    <mat-form-field class="example-full-width">
      <input type="text" matInput placeholder="Name" 
      [(ngModel)]="Name"
      >
    </mat-form-field>
  
    <mat-form-field class="example-full-width">
      <input type="text" matInput placeholder="Description" 
      [(ngModel)]="Description"
      
      >
    </mat-form-field>

    <mat-form-field class="example-full-width">
      <input type="number" matInput placeholder="Expiry Months" 
      [(ngModel)]="ExpiryMonths"
      >
    </mat-form-field>
 
    <!-- <mat-form-field *ngIf="data.edit"> -->
    <mat-form-field>
      <mat-label>Active/Inactive</mat-label>
      <mat-select [(ngModel)]="selectedStatus">
        <mat-option [value]="1">Active</mat-option>
        <mat-option [value]="0">Inactive</mat-option>
      </mat-select>
    </mat-form-field>

 
</div>
<div mat-dialog-actions class="dialogControllBtn">
  <button mat-raised-button (click)="onNoClick()">Cancel</button>
  <button mat-raised-button (click)="onSubmitClick()" cdkFocusInitial>Submit</button>
</div>